var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZendesk = function SvgZendesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2301_173445)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02363D",
    stroke: "#fff",
    strokeWidth: 1.438,
    d: "m21.012 3.089 12.16 7.039a2.77 2.77 0 0 1 1.379 2.393V26.6c0 .988-.526 1.9-1.378 2.393l-12.161 7.039a2.75 2.75 0 0 1-2.754 0l-12.16-7.039A2.77 2.77 0 0 1 4.718 26.6V12.52c0-.988.526-1.9 1.378-2.393l12.161-7.039a2.75 2.75 0 0 1 2.754 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.099 16.646v9.22h-7.637zM19.099 13.337a3.818 3.818 0 0 1-7.637 0zM20.357 25.866a3.818 3.818 0 0 1 7.637 0zM20.357 22.557v-9.22h7.638z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2301_173445",
    width: 38.891,
    height: 42.741,
    x: 0.19,
    y: 0.095,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.905
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.905
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2301_173445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2301_173445",
    result: "shape"
  })))));
};
export default SvgZendesk;